import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-20 border-t" style={{ borderColor: "var(--pe-border)", background: "var(--pe-bg-soft)" }} data-testid="site-footer">
      <div className="pe-container py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-display font-extrabold text-2xl tracking-tight" style={{ color: "var(--pe-primary)" }}>
            PROPER ENERGY
          </div>
          <p className="mt-3 text-sm text-[color:var(--pe-text-muted)] max-w-md leading-relaxed">
            PT Proper Energy Indonesia — PLTS residensial yang direncanakan untuk kebutuhan rumah hari ini, siap tumbuh untuk kebutuhan berikutnya.
          </p>
          <p className="mt-4 text-xs text-[color:var(--pe-text-muted)]">Secure Energy Living</p>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">Navigasi</h4>
          <ul className="space-y-2 text-sm text-[color:var(--pe-text-muted)]">
            <li><Link to="/plts-tumbuh" className="hover:text-[color:var(--pe-primary)]">PLTS Tumbuh</Link></li>
            <li><Link to="/simulasi" className="hover:text-[color:var(--pe-primary)]">Simulasi</Link></li>
            <li><Link to="/konfigurator" className="hover:text-[color:var(--pe-primary)]">Konfigurator</Link></li>
            <li><Link to="/rencana-tumbuh" className="hover:text-[color:var(--pe-primary)]">Rencana Tumbuh</Link></li>
            <li><Link to="/mitra" className="hover:text-[color:var(--pe-primary)]">Mitra</Link></li>
            <li><Link to="/privasi" className="hover:text-[color:var(--pe-primary)]">Privasi</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">Kontak</h4>
          <ul className="space-y-3 text-sm text-[color:var(--pe-text-muted)]">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 shrink-0" /><a href="https://wa.me/6285121341168" className="hover:text-[color:var(--pe-primary)]" data-testid="footer-wa">+62 851-2134-1168</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 shrink-0" /><a href="mailto:office@properenergy.id" className="hover:text-[color:var(--pe-primary)]">office@properenergy.id</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 shrink-0" /><span>Jl. Bintaro Raya Selatan No.8, Kebayoran Lama, Jakarta Selatan 12240</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t py-5 text-center text-xs text-[color:var(--pe-text-muted)]" style={{ borderColor: "var(--pe-border)" }}>
        © {new Date().getFullYear()} PT Proper Energy Indonesia. Simulasi & estimasi adalah perkiraan awal — penawaran final menyusul setelah survei.
      </div>
    </footer>
  );
}
